{
  "name": "@blockdaemon/tokenization-widget",
  "version": "0.7.0",
  "private": true,
  "type": "module",
  "exports": {
    ".": "./src/main.tsx",
    "./router": {
      "types": "./src/create-tokenization-router.d.ts",
      "default": "./src/create-tokenization-router.tsx"
    },
    "./config": "./src/providers/tokenization-widget-config-provider.tsx",
    "./config-loader": "./src/config-loader.ts",
    "./config-schema": "./src/config-schema.ts",
    "./showcase-adapter": "./src/showcase-adapter.tsx",
    "./locales/*": "./src/locales/*",
    "./demo": {
      "workerd": "./worker/config/demo.json",
      "worker": "./worker/config/demo.json",
      "module": "./worker/config/demo.json",
      "browser": "./worker/config/demo.json",
      "development": "./worker/config/demo.json",
      "import": "./worker/config/demo.json",
      "default": "./worker/config/demo.json"
    }
  },
  "scripts": {
    "dev": "vite dev --port 5174",
    "build": "vite build",
    "routes:generate": "tsr generate",
    "typecheck": "tsc --noEmit && tsc --noEmit -p tsconfig.node.json"
  },
  "dependencies": {
    "@blockdaemon-internal/design-system": "catalog:",
    "@blockdaemon/bd-sdk": "catalog:",
    "@blockdaemon/widget-config": "workspace:*",
    "@blockdaemon/widget-host": "workspace:*",
    "@blockdaemon/widget-metadata": "workspace:*",
    "@blockdaemon/widget-shell": "workspace:*",
    "@blockdaemon/widget-tooling": "workspace:*",
    "@blockdaemon/widget-worker": "workspace:*",
    "@lingui/core": "catalog:",
    "@lingui/react": "catalog:",
    "@mantine/core": "catalog:",
    "@mantine/hooks": "catalog:",
    "@mantine/spotlight": "catalog:",
    "@reown/appkit": "catalog:",
    "@sentry/react": "catalog:",
    "@tanstack/react-query": "catalog:",
    "@tanstack/react-router": "catalog:",
    "@walletconnect/universal-provider": "catalog:",
    "buffer": "catalog:",
    "hono": "catalog:",
    "lucide-react": "catalog:",
    "posthog-js": "catalog:",
    "react": "catalog:",
    "react-dom": "catalog:",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@lingui/babel-plugin-lingui-macro": "catalog:",
    "@tanstack/router-cli": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "babel-plugin-react-compiler": "catalog:",
    "bun-types": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:"
  }
}
